import React from "react";
import { EmployeeAccountBalanceContainer } from "../../../containers";

const EmployeeAccountBalance = (props) => {
  return <EmployeeAccountBalanceContainer {...props} />;
};

export default EmployeeAccountBalance;
